module.exports = __webpack_public_path__ + "static/8_bien_2-9b79803d464c5436ca88d0fb5505e701.jpg";